import { atom } from 'jotai'

export const tradeTabAtom = atom<number>(0)
export const tradeTabTrackBgAtom = atom<string>('linear-gradient(180deg, #1EA7E4 0%, #01BBBE 100%)')
